const TimeoutContent = {
    Message_session_expired: "Your session expired. You will be automatically logged out.",
    Button_keep_logged: "Keep me logged in",
    Main_message: "You haven't used your session for a while. For your security, we will log you out soon.",
    Header: "Session timeout",
    Button_logout: "Log out",
    Message_session_exceed_limit:
        "Your session will soon exceed the session limit. For your security we will log you out soon.",
};

export default TimeoutContent;
